export default "__VITE_ASSET__CeUY$hgt__"